import { IPageSettings } from "../../interfaces/IPageSettings";
import { OneDriveState } from "../../types";
import { typedAction } from "../helpers";
import { RESET_DRIVE_LOCATION_BEFORE_SAVING, SET_ONE_DRIVE_LOCATION_BEFORE_SAVING } from "./actionTypes";

const initialState: OneDriveState = { locationBeforeSaving: [] };

export const setLocationBeforeSaving = (locationBeforeSaving: IPageSettings[]) => {
    return typedAction(SET_ONE_DRIVE_LOCATION_BEFORE_SAVING, locationBeforeSaving);
};

export const resetLocationBeforeSaving = () => {
    return typedAction(RESET_DRIVE_LOCATION_BEFORE_SAVING);
};

type OneDriveAction = ReturnType<typeof setLocationBeforeSaving | typeof resetLocationBeforeSaving>;

export function oneDriveReducer(
    state = initialState,
    action: OneDriveAction
): OneDriveState {
    switch (action.type) {
        case SET_ONE_DRIVE_LOCATION_BEFORE_SAVING:
            return { locationBeforeSaving: action.payload };
        case RESET_DRIVE_LOCATION_BEFORE_SAVING:
            return { locationBeforeSaving: [] };
        default:
            return state;
    }
}